// extracted by mini-css-extract-plugin
export default {"article":"Article_article__rqSqJ","title":"Article_title__i9mlz","intro":"Article_intro__+Erlq","date":"Article_date__BWPOI"};